import { useEffect, useState } from "react";

export default function Loader({ onDone }) {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), 1800);
    const t2 = setTimeout(() => onDone(), 2500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "#ffffff",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      zIndex: 9999,
      opacity: fading ? 0 : 1,
      transition: "opacity 0.7s ease",
      pointerEvents: "none"
    }}>
      <img
        src="/assets/logo.svg"
        alt="RepoScan"
        style={{
          height: 60,
          width: "auto",
          animation: "pulse-logo 1.6s ease-in-out infinite"
        }}
      />
      <p style={{
        marginTop: 16,
        fontSize: 13,
        color: "#94a3b8",
        letterSpacing: "0.05em"
      }}>
        RepoScan
      </p>
    </div>
  );
}
